import { useQuery } from '@tanstack/react-query';
import getEntity from '@teetsh/app/src/queries/share/getEntity';
import { Classroom } from 'types/classroom';

export function useGetShareEDTClassrooms(token: string, edtId: string) {
  return useQuery({
    queryKey: ['edtShareClassrooms'],
    queryFn: () =>
      getEntity({
        token,
        entityType: 'emploiDuTemps',
        entityId: edtId,
      }).then(({ edtClassrooms }) =>
        // TODO: get real classrooms to fix some strange behaviors?
        Object.entries(edtClassrooms).map(
          ([name, id]) => ({ name, id } as Classroom),
        ),
      ),
    refetchOnWindowFocus: false,
    retry: (failCount, err) => {
      if (err?.response?.status === 404) {
        return false;
      }
      return failCount < 1;
    },
  });
}
